import { SeparatedWaste } from "../householdHabits/householdHabitsSlice";

interface SeparatedWasteOption {
  label: string;
  value: keyof SeparatedWaste;
}

export const SEPARATED_WASTE_OPTIONS: SeparatedWasteOption[] = [
  {
    label: "Vidrio",
    value: "glass",
  },
  {
    label: "Plástico",
    value: "plastic",
  },
  {
    label: "Papel y cartón",
    value: "paperAndCardboard",
  },
  {
    label: "Orgánico",
    value: "organic",
  },
];
